var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2085662285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0795 6.375C14.2468 6.375 14.4072 6.44085 14.5255 6.55806C14.6438 6.67527 14.7102 6.83424 14.7102 7V8.25H17.233C17.4002 8.25 17.5606 8.31585 17.6789 8.43306C17.7972 8.55027 17.8636 8.70924 17.8636 8.875V16.375H19.125V17.625H5.25V16.375H6.51136V8.875C6.51136 8.70924 6.57781 8.55027 6.69609 8.43306C6.81436 8.31585 6.97478 8.25 7.14205 8.25H9.66477V7C9.66477 6.83424 9.73122 6.67527 9.8495 6.55806C9.96777 6.44085 10.1282 6.375 10.2955 6.375H14.0795ZM9.66477 9.5H7.77273V16.375H9.66477V9.5ZM13.4489 9.5H10.9261V16.375H13.4489V9.5ZM16.6023 9.5H14.7102V16.375H16.6023V9.5ZM13.4489 7.625H10.9261V8.25H13.4489V7.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.1d496da7841d6f3e8765cd8c0e8e7d23.svg";
export { ForwardRef as ReactComponent };